import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Mission } from "./components/site/Mission";
import { Vision } from "./components/site/Vision";
import { Purpose } from "./components/site/Purpose";
import { Ripple } from "./components/site/Ripple";
import { Founder } from "./components/site/Founder";
import { Join } from "./components/site/Join";
import { Footer } from "./components/site/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-[#F9F8F6]">
      <Nav />
      <Hero />
      <Mission />
      <Vision />
      <Purpose />
      <Ripple />
      <Founder />
      <Join />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#2D3730",
            color: "#F9F8F6",
            border: "1px solid #8A9A86",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
            fontSize: "14px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
